// Дата текущей редакции политики (ISO). Меняется вместе с текстом политики.
export const PRIVACY_POLICY_REVISION = "2026-11-02";
